var v1="<div class=\"companyReference\"> <lba-company-reference-grid settings=\"vm.gridDetails\" data=\"vm.companyReferences\">why wont it work</lba-company-reference-grid> <div ng-if=\"vm.LoadingCompanyReference\">Loading Data Please Wait...</div> <lba-company-reference-item-form ng-if=\"vm.editorActive\" active-company-reference=\"vm.activeCompanyReference\" toggle-detail=\"vm.toggleDetail\" save-item=\"vm.saveItem\" set-load-form=\"vm.setLoadForm\"></lba-company-reference-item-form> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaCompanyReference.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaCompanyReference/lbaCompanyReference.html
// module id = 367
// module chunks = 0